/**
 * The SYCEBNL vertical's sidebar entries.
 *
 * Each is anchored to the section it belongs to rather than appended: the
 * accounting group is divided by `heading` items, and an appended entry
 * would land under whichever heading happens to come last.
 *
 * The `only: ['SYCEBNL']` gating is the regime axis and is unchanged by the
 * move. Module and regime stay orthogonal — the module says this vertical
 * has these screens, the regime says this tenant is under SYCEBNL.
 */
import { FileBarChart2, HandCoins, PiggyBank } from 'lucide-react';
import type { NavContribution } from '../types';

export const associationNav: readonly NavContribution[] = [
  {
    intoGroup: 'accounting',
    after: 'accounting-supporting-documents',
    items: [
      // Donor register: a SYCEBNL book (art. 17), so that regime only.
      { key: 'accounting-donor-register', href: '/accounting/registre-donateurs', icon: HandCoins, labelKey: 'nav.accounting.donorRegister', permission: 'accounting:read', regimes: { only: ['SYCEBNL'] } },
      // Restricted and administration funds: accounts 16x/46x exist in the
      // SYCEBNL chart only.
      { key: 'accounting-funds', href: '/accounting/fonds-affectes', icon: PiggyBank, labelKey: 'nav.accounting.funds', permission: 'accounting:read', regimes: { only: ['SYCEBNL'] } },
    ],
  },
  {
    intoGroup: 'accounting',
    after: 'accounting-statements',
    items: [
      // The two statement sets are exclusive: SYSCOHADA everywhere except
      // SYCEBNL, and the SYCEBNL set (ASSOCIATION profile) under SYCEBNL.
      { key: 'accounting-etats-sycebnl', href: '/accounting/etats-sycebnl', icon: FileBarChart2, labelKey: 'nav.accounting.statementsSycebnl', permission: 'accounting:read', regimes: { only: ['SYCEBNL'] } },
    ],
  },
];
